import { render, staticRenderFns } from "./CircleConferenceMembers.vue?vue&type=template&id=56a33b9a&scoped=true"
import script from "./CircleConferenceMembers.vue?vue&type=script&lang=js"
export * from "./CircleConferenceMembers.vue?vue&type=script&lang=js"
import style0 from "./CircleConferenceMembers.vue?vue&type=style&index=0&id=56a33b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33b9a",
  null
  
)

export default component.exports